// import { Pagination } from 'swiper/modules';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import Zoom from 'react-medium-image-zoom';
import { Link } from 'react-router';
import { CSSTransition } from 'react-transition-group';
import { Swiper, SwiperSlide } from 'swiper/react';
import canalsSrc from '../../../assets/images/canals.png';
import cariesSrc from '../../../assets/images/caries.png';
import certificate1 from '../../../assets/images/d_certificate_1.jpg';
import certificate2 from '../../../assets/images/d_certificate_2.jpg';
import certificate3 from '../../../assets/images/d_certificate_3.jpg';
import gigiensSrc from '../../../assets/images/gigiens.png';
import LogoPng from '../../../assets/images/logo2.png';
import otbelivanieSrc from '../../../assets/images/otbelivanie.png';
import photo from '../../../assets/images/photo_1.jpg';
import vinirsSrc from '../../../assets/images/vinirs.png';
import CloseIcon from '../../../components/Icons/CloseIcon';
import InstagramIcon from '../../../components/Icons/InstagramIcon';
import LocationIcon from '../../../components/Icons/LocationIcon';
import PhoneIcon from '../../../components/Icons/PhoneIcon';
import IntersectionWrapper from '../../../components/IntersectionWrapper/IntersectionWrapper';
import s from './MainMobile.module.scss';

const certificatesList = [certificate1, certificate2, certificate3];

const reviewsList = [
  {
    id: 1,
    rating: 5,
    name: 'Сергей Понасенков',
    text: `Никогда не думал, что скажу: "Хожу в стоматологию с удовольствием"! Спасибо Зареме Идрисовне за её чуткое отношение и профессионализм. Она находит подход даже к самым нервным пациентам и всегда заботится о комфорте. Абсолютно не чувствую боли во время лечения. Очень благодарен!`,
  },
  {
    id: 2,
    rating: 4.4,
    name: 'Иванова Анастасия',
    text: 'Газдиева Зарема Идрисовна удаляла мне зубной камень и налет, очень хороший специалист, эффект держится долго. Зарема Идрисовна у вас золотые руки! Если бы вы знали как хорошо она пломбы делает - не больно, быстро и качественно! Довольна всем!!!',
  },
  {
    id: 3,
    rating: 4.9,
    name: 'Милана Хамчиева',
    text: 'Когда мне нужно было сделать пломбу, я выбрала Зарему, и не ошиблась. Она объяснила все шаги, работала быстро и аккуратно. Все прошло просто отлично, а результат превзошел все ожидания. Обязательно буду обращаться только к ней',
  },
  {
    id: 4,
    rating: 5,
    name: 'Алина',
    text: 'Не могу не отметить высокий профессионализм Заремы. Я пришла к ней с болями в зубе, и она быстро нашла причину и устранила её. Очень внимательная, чуткая и, что немаловажно, умело создающая атмосферу доверия. Приятно обращаться к настоящему специалисту',
  },
  {
    id: 5,
    rating: 4.7,
    name: 'Ольга Мизинова',
    text: 'К доктору  Зареме Идрисовне попала уже после не совсем успешного лечения 3-х канального зуба в другой клинике. Провела тщательную диагностику, сумела ликвидировать последствия неудачного лечения и сохранить зуб!!! Бесконечная моя благодарность!',
  },
];

const stars = Array(5).fill();
const calculateRating = (number) => (number / 5) * 100;

const servicesList = [
  {
    text: 'Лечение кариеса',
    icon: <img src={cariesSrc} />,
    price: '7000р.',
  },
  {
    text: 'Профессиональная гигиена полости рта',
    icon: <img src={gigiensSrc} />,
    price: '5000р.',
  },
  {
    text: 'Лечение каналов',
    icon: <img src={canalsSrc} />,
    price: 'от 6000р.',
  },
  {
    text: 'Коронки, виниры',
    icon: <img src={vinirsSrc} />,
    price: '25000р.',
  },
  {
    text: 'Отбеливание Zoom4',
    icon: <img src={otbelivanieSrc} />,
    price: '25000р.',
  },
];

const advantagesList = [
  'Современные технологии и оборудование',
  'Квалифицированные специалисты',
  'Использование качественных материалов',
  'Комфорт и безболезненность',
  'Гибкая система записи и удобный график работы',
];

const educationList = [
  'ФГАОУ ВПО «Северо-Восточный федеральный университет имени М.К. Аммосова» г. Якутск, специальность «Стоматология» (2015 г.)',
  'ФГБОУ ВО «Северо-Западный государственный медицинский университет имени И.И. Мечникова» Министерства здравоохранения Российской Федерации. Присвоена квалификация «Стоматология общей практики» (2016 г.)',
  'ФГБОУ ВО «Северо-Западный государственный медицинский университет имени И.И. Мечникова» Министерства здравоохранения Российской Федерации, «Стоматология хирургическая» (2016 г.)',
  '2018 г. - «Адгезивные керамические реставрации в практике врача-стоматолога», Карэн Чувашьян',
  '2018 г. - Первый стоматологический конгресс по эндодонтии ProEndo, Михаил Соломонов',
];

const ContentMobile = () => {
  const [activeReview, setActiveReview] = useState(false);

  useEffect(() => {
    if (activeReview) {
      document.documentElement.classList.add('modalOpen');
    } else {
      document.documentElement.classList.remove('modalOpen');
    }
  }, [activeReview]);

  const renderReviews = (rating) => (
    <div className={s.stars}>
      <div className={s.stars_empty}>
        {stars.map((_, index) => (
          <i key={index} className="fa-regular fa-star" />
        ))}
      </div>
      <div className={s.stars_filled} style={{ width: `${calculateRating(rating)}%` }}>
        {stars.map((_, index) => (
          <i key={index} className="fa-solid fa-star" />
        ))}
      </div>
    </div>
  );
  console.log({ activeReview });
  return (
    <>
      <div className={s.container}>
        <header>
          <div className={s.address}>
            <LocationIcon size={'24px'} color={'#4aaca7'} />
            <div className={s.address_site}>
              <span>Москва, Одинцово</span>
              <span>м.Профсоюзная, Нахимовский проспект 65</span>
            </div>
            <div className={s.address_shedule}>
              <span>Пн-Вс:</span>
              <span>10:00-20:00</span>
            </div>
            <a href="instagram://user?username=dr.zemagazdieva" className={s.address_link}>
              <InstagramIcon size="24px" color="#dc7878" />
            </a>
          </div>
        </header>
        <section id="headerInfo" className={s.headerInfo}>
          <div className={s.mainInfo}>
            <div className={s.logo}>
              <img src={LogoPng} alt="Логотип стоматологической клиники в Москве" />
            </div>
            <div className={s.record}>
              <h3>Запись на прием</h3>
              <div className={s.buttons}>
                <a href="https://api.whatsapp.com/send?phone=79111146566&text=Здравствуйте, хотел бы записаться на прием...">
                  <FontAwesomeIcon icon={faWhatsapp} size="30px" />
                </a>
                <Link to={'/question'}>
                  <FontAwesomeIcon icon={faEnvelope} size="30px" />
                </Link>
              </div>
            </div>
          </div>
          <div className={s.baseInfo}>
            <div className={s.baseInfo_title}>
              <h1>Газдиева Зарема Идрисовна</h1>
              <span>Стоматолог-терапевт, стоматолог-ортопед</span>
            </div>
            <div className={s.baseInfo_info}>
              <div className={s.baseInfo_info__image}>
                <img src={photo} alt="Стоматолог Газдиева Зарема Идрисовна" />
              </div>
              <ul className={s.header_info__education}>
                {educationList.map((text, index) => (
                  <li key={index}>- {text}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>
        <section id="about" className={s.about}>
          <h2>Стоматологическая клиника доктора Заремы</h2>
          <p>
            Клиника, в которой быстро, профессионально и по приемлемым ценам вас избавят от зубной боли, вернут
            возможность наслаждаться любимой едой, счастливо улыбаться и весело смеятся{' '}
          </p>
        </section>

        <section id="services" className={s.services}>
          <IntersectionWrapper className={s.container}>
            {servicesList.map(({ price, text, icon }, index) => (
              <div key={index} className={s.item}>
                <div className={s.item_wrapper}>
                  <div className={s.item_wrapper__icon}>{icon}</div>
                  <div className={s.item_wrapper__text}>{text}</div>
                </div>
                <div className={s.item_price}>{price}</div>
              </div>
            ))}
          </IntersectionWrapper>
        </section>

        <section id="advantages" className={s.advantages}>
          <IntersectionWrapper className={s.container}>
            <h3>Нас выбирают из-за наших преимуществ: </h3>
            <div className={s.list}>
              {advantagesList.map((text, index) => (
                <span key={index}>{text}</span>
              ))}
            </div>
          </IntersectionWrapper>
        </section>

        <section id="reviews" className={s.reviews}>
          <IntersectionWrapper className={s.container}>
            <>
              <h2>Отзывы наших клиентов</h2>
              <div className={s.reviews_wrapper}>
                {reviewsList.map(({ id, name, text, rating }) => {
                  return (
                    <div key={id} className={s.item} onClick={() => setActiveReview({ text, rating, name })}>
                      <div className={s.item_title}>
                        <div>{name}</div>
                        {renderReviews(rating)}
                      </div>
                      <div className={s.item_content}>{text}</div>
                    </div>
                  );
                })}
              </div>
            </>
          </IntersectionWrapper>
        </section>

        <section id="certificates" className={s.certificates}>
          <h2>Мы профессионалы</h2>
          <Swiper
            className={s.swiper}
            spaceBetween={20}
            pagination={{
              clickable: true,
            }}
            slidesPerView={2}
          >
            {certificatesList.map((certificateImg, index) => {
              return (
                <SwiperSlide key={index}>
                  <Zoom>
                    <img src={certificateImg} alt={`Сертификат врача стоматолога №${index + 1}`} />
                  </Zoom>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </section>

        <section id="site" className={s.site}>
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A1d451f3edab5e61c65469690322b32df7e3ab2903935dee612570c3c66d7ebeb&amp;source=constructor"
            width="400"
            height="400"
            frameBorder="0"
          />
        </section>
        <a href="tel:89111146566" className={s.phone}>
          <PhoneIcon size={'50px'} color="#4aaca7" />
        </a>
      </div>
      {/* <footer>
        <div className={s.footerWrapper}>
          <div className={s.logo}>
            <img src={LogoPng} />
          </div>
          <div className={s.footerShortInfo}>
            <div className={s.footerShortInfo_message}>Будем рады Вас видеть!</div>
            <div> г. Москва, Одинцово, Нахимовский проспект 65, м.Профсоюзная</div>
            <div>Понедельник-Воскресенье: 10:00-20:00</div>
          </div>
        </div>
      </footer> */}

      <CSSTransition
        classNames={{
          enter: s.enter,
          enterActive: s.enterActive,
          exit: s.exit,
          exitActive: s.exitActive,
        }}
        timeout={500}
        unmountOnExit
        appear
        in={!!activeReview?.name}
      >
        <div className={s.wrapper}>
          <div className={s.modal}>
            <div className={s.name}>{activeReview.name}</div>
            <div className={s.rating_2}>{renderReviews(activeReview.rating)}</div>
            <div className={s.review}>{activeReview.text}</div>
            <div className={s.icon}>
              <CloseIcon onClick={() => setActiveReview(false)} size="20px" />
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};

export default ContentMobile;
